<div style="display: flex;flex-direction: row-reverse;cursor:pointer;">
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
<textarea *ngIf="isInspector" #textArea [(ngModel)]="comment" autocomplete="off"  autocorrect="off" autocapitalize="off" spellcheck="false" ></textarea>
<span *ngIf="!isInspector">{{comment}}</span>
<button *ngIf="isInspector" mat-raised-button class="button" color="warn" (click)="updateComment()" [class.loading]="savingComment" [disabled]="savingComment"><span>{{'Save Comment' | translate | async}}</span></button>
